import React from "react";
import { LineChart } from '@mui/x-charts/LineChart';

function XmesiYmotiviAnnullamenti({
    data,
    titolo,
    displayTitolo,
    settings
}) {


    let dataset = [];
    let keyToLabel = {};

    if (settings.series.magazzino) {
        keyToLabel.magazzino = "magazzino assente";
    }

    if (settings.series.annullato) {
        keyToLabel.annullato = "annullato da cliente";
    }

    if (settings.series.no_pagamento) {
        keyToLabel.no_pagamento = "pagamento non arrivato";
    }

    if (settings.series.destinatario) {
        keyToLabel.destinatario = "destinatario assente";
    }

    if (settings.series.fuoriUE) {
        keyToLabel.fuoriUE = "impossibile spedire - fuori UE";
    }

    if (settings.series.err_pagamento) {
        keyToLabel.err_pagamento = "errore pagamento";
    }

    if (settings.series.mancanza_tempo) {
        keyToLabel.mancanza_tempo = "mancanza di tempo";
    }


    if (data.dataSet) {
        dataset = data.dataSet;
    }
    console.log("dataset", dataset)

    let mutantValueFormatter = (value) => value

    if (settings.robaDaSommare === 'ordini') {
        mutantValueFormatter = (value) => !value ? 0 : value
    } else if (settings.robaDaSommare === 'importo') {
        mutantValueFormatter = (value) => !value ? 0 : value.toString().replace('.', ',').replace(/\d(?=(?:(?:\d{3})+),)/g, match => `${match}.`) + " €";
    }

    const colors = {
        magazzino: "#ff9800",
        annullato: "#009688",
        no_pagamento: "#1565c0",
        destinatario: "#9c27b0",
        fuoriUE: "#b71c1c",
        err_pagamento: "#e91e63",
        mancanza_tempo: "#7b1fa2"
    };

    const xData = dataset.map((row) => new Date(row.year_month_combined))

    const customize = {
        height: 700,
        /* legend: { hidden: true }, */
        margin: { top: 5 },
        stackingOrder: 'descending',
        xAxis: [
            {
                data: xData,
                scaleType: 'time',
                valueFormatter: (v) => v.toLocaleString('it-IT', {
                    year: "2-digit",
                    month: "2-digit",
                })
            }
        ]


    };

    let stackStrategy;

    if (settings.stack) {
        stackStrategy = {
            stack: 'total',
            area: true,
            stackOffset: 'none', // To stack 0 on top of others
            stackOrder: 'reverse'
        };
    }
    

    const series = Object.keys(keyToLabel).map((key) => ({
        dataKey: key,
        label: keyToLabel[key],
        valueFormatter: (v) => mutantValueFormatter(v),
        /* connectNulls: true, */
        color: colors[key],
        showMark: false,
        ...stackStrategy,
    }))



    console.log("series", series)


    if (data) {
        return (
            <div>
                {titolo && displayTitolo && <div className="tc sfondoColChiaro pa2 b">{titolo}</div>}
                {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
                <div className="pa2 flex flex-wrap items-center">
                    <LineChart
                        series={series}
                        dataset={dataset}
                        {...customize}
                    />
                </div>
            </div>
        )
    } else {
        return (<div>no data</div>)
    }

}

export default XmesiYmotiviAnnullamenti;
